import type { ChatFile } from 'src/api/squad/types.gen'
import type { ChatAttachment, ChatMessage } from 'src/components/chat'

import { toChatAttachment } from './squadFilesApi'

/** `files` of a `/messages/` entry: uploads on the user turn, files the agent
 * created on the assistant turn. */
export const attachmentsOf = (
  files: ChatFile[] | undefined
): Pick<ChatMessage, 'attachments'> =>
  files?.length ? { attachments: files.map(toChatAttachment) } : {}

/** A reconnect replays the run's steps, so the same `file` event can arrive
 * twice; the file must show once, where it already is, keeping its link. */
export const withAttachment = (
  messages: ChatMessage[],
  messageId: string,
  attachment: ChatAttachment
): ChatMessage[] =>
  messages.map((message) => {
    if (message.id !== messageId) return message

    const current = message.attachments ?? []
    const existing = current.find((item) => item.id === attachment.id)

    return {
      ...message,
      attachments: existing
        ? current.map((item) =>
            item.id === attachment.id
              ? { ...item, ...attachment, url: attachment.url ?? item.url }
              : item
          )
        : [...current, attachment]
    }
  })
